/*
 *
 * MeasurementHistory actions
 *
 */

import {
  CREATE_MEASUREMENT_WATCHER,
  CREATE_MEASUREMENT_SUCCESS,
  CREATE_MEASUREMENT_FAILED,
  LIST_SURVEYS_WATCHER,
  LIST_SURVEYS_SUCCESS,
  LIST_SURVEYS_FAILED,
  LIST_MEASUREMENTS_WATCHER,
  LIST_MEASUREMENTS_SUCCESS,
  LIST_MEASUREMENTS_FAILED,
  DELETE_MEASURE_WATCHER,
  DELETE_MEASURE_SUCCESS,
  DELETE_MEASURE_FAILED,
  HAS_COLLABORATORS_WATCHER,
  HAS_COLLABORATORS_SUCCESS,
  HAS_COLLABORATORS_FAILED,
} from "./constants"

// DELETE MEASUREMENT
export function hasCollaboratorsWatcher(payload) {
  return {
    type: HAS_COLLABORATORS_WATCHER,
    payload,
  }
}

export function hasCollaboratorsSuccess(payload) {
  return {
    type: HAS_COLLABORATORS_SUCCESS,
    payload,
  }
}

export function hasCollaboratorsFailed(payload) {
  return {
    type: HAS_COLLABORATORS_FAILED,
    payload,
  }
}

// DELETE MEASUREMENT
export function deleteMeasureWatcher(payload) {
  return {
    type: DELETE_MEASURE_WATCHER,
    payload,
  }
}

export function deleteMeasureSuccess(payload) {
  return {
    type: DELETE_MEASURE_SUCCESS,
    payload,
  }
}

export function deleteMeasureFailed(payload) {
  return {
    type: DELETE_MEASURE_FAILED,
    payload,
  }
}

// LIST SURVEYS
export function listMeasurementsWatcher(payload) {
  return {
    type: LIST_MEASUREMENTS_WATCHER,
    payload,
  }
}

export function listMeasurementsSuccess(payload) {
  return {
    type: LIST_MEASUREMENTS_SUCCESS,
    payload,
  }
}

export function listMeasurementsFailed(payload) {
  return {
    type: LIST_MEASUREMENTS_FAILED,
    payload,
  }
}

// LIST SURVEYS
export function listSurveysWatcher(payload) {
  return {
    type: LIST_SURVEYS_WATCHER,
    payload,
  }
}

export function listSurveysSuccess(payload) {
  return {
    type: LIST_SURVEYS_SUCCESS,
    payload,
  }
}

export function listSurveysFailed(payload) {
  return {
    type: LIST_SURVEYS_FAILED,
    payload,
  }
}

// CREATE MEASUREMENT
export function createMeasurementWatcher(payload) {
  return {
    type: CREATE_MEASUREMENT_WATCHER,
    payload,
  }
}

export function createMeasurementSuccess(payload) {
  return {
    type: CREATE_MEASUREMENT_SUCCESS,
    payload,
  }
}

export function createMeasurementFailed(payload) {
  return {
    type: CREATE_MEASUREMENT_FAILED,
    payload,
  }
}
